<!-- 活动评选分析 -->
<template>
    <div class="activity-review">
          <div class="activity-review-top">
              <div class="title">活动评审</div>
              <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
          </div>
          <div class="activity-review-number">
              <div class="activity-review-number-item" v-for="(item,index) in activityNumList" :key="index">
                  <div class="name">{{ item.name }}</div>
                  <count-up
                      class="infor-card-count user-created-count"
                      :id-name="`code_${item.name}`"
                      :end-val="item.number"
                      color="#FFFFFF"
                      countSize="16px"
                      :countWeight="700"
                      :isConvert="1"
                      style="height:100%;"
                  >
                  </count-up>
              </div>
          </div>
          <div class="activity-review-progress">
              <div class="rank-li" v-for="(item,index) in activityList" :key="item.id">
                  <div class="subject-name">{{ item.title }}</div>
                  <div class="rate">
                      <el-progress class="rank-progress" :color="'#2B7FFF'" :define-back-color="'#00000000'"  :duration="3" :intermediate="true" :show-text="false" :percentage="item.progress" :stroke-width="16"></el-progress>
                      <div class="number">{{ item.number }}</div>
                  </div>
              </div>
          </div>
          <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
          <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
          <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
          <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
      </div>
  </template>
  
  <script>
  import { getActivityReviewInfoAPI } from "@/service/api.js"
  import CountUp from "@/components/countUp.vue";
  export default {
    name: 'activity-review',
    components: {
      CountUp
    },
    props:{
      //请求参数
      params: {
          type: Object,
          default: ()=>{}
      },
    },
    data() {
        return {
              activityNumList:[
                {
                    name:'活动数',
                    number:354
                },
                {
                    name:'作品提交数',
                    number:652
                },
                {
                    name:'获奖作品数',
                    number:231
                }
              ],
              activityList:[
                {
                    id:1,
                    title:'全区师生阅读推荐',
                    number:1369,
                    progress:100
                },
                {
                    id:2,
                    title:'区小学首届网络课程大赛',
                    number:1205,
                    progress:92
                },
                {
                    id:3,
                    title:'区小学英语测验',
                    number:1105,
                    progress:90
                },
                {
                    id:4,
                    title:'区小学数学测验',
                    number:1021,
                    progress:85
                },
                {
                    id:5,
                    title:'区小学语文测验',
                    number:1021,
                    progress:85
                }
              ],
        }
    },
    watch:{
      params: {
        deep: true,
        handler (val) {
          this.getActivityReviewInfo();
        }
      }
    },
    methods: {

    },
    mounted(){ 

    },
  }
  </script>
  
  <style lang="scss" scoped>
  .activity-review{
      width: 100%;
      height: 290px;
      padding: 0 15px;
      background: rgba(6,17,52,0.8);
      border: 1px solid #053882;
      // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
      margin-bottom: 20px;
      position: relative;
      .activity-review-top{
          position: relative;
          text-align: center;
          margin-bottom: 14px;
          .title{
              display: inline-block;
              padding: 9px 22px 8px 17px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #D0E7FE;
              line-height: 20px;
              position: relative;
              z-index: 2;
          }
          .more{
              display: inline-block;
              position: absolute;
              top: 0px;
              right: 0px;
              height: 100%;
              line-height: 44px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #359AFF;
              cursor: pointer;
          }
          .title-bg{
              width: auto;
              height: 100%;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
          }
      }
      .activity-review-number{
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-bottom: 14px;
          .activity-review-number-item{
              display: flex;
              align-items: center;
              .name{
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #7ABFDB;
                  margin-right: 5px;
              }
              .number{
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  color: #FFFFFF;
              }
          }
      }
      .activity-review-progress{
          .rank-li{
              width: 100%;
              height: 16px;
              display: flex;
              align-items: center;
            //   margin-bottom: 9px;
              margin: 25px 0;
              .subject-name{
                  width: 100px;
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #6EA0D3;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  text-align: left;
                  line-height: 16px;
              }
              .rate{
                  width: calc(100% - 100px);
                  display: flex;
                  align-items: center;
                  .rank-progress{
                      width: calc(100% - 75px);
                  }
                  .number{
                      margin-left: 5px;
                      display: inline-block;
                      width: 70px;
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #7ABFDB;
                      text-align: right;
                      line-height: 16px;
                  }
              }
          }
          .rank-li:last-child{
              margin-bottom: 0;
          }
      }
      .top-left{
          position: absolute;
          top: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .top-right{
          position: absolute;
          top: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
      .left-bottom{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .right-bottom{
          position: absolute;
          bottom: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
  }
  </style>
  <style lang="scss">
  .activity-review{
      .activity-review-progress{
          .rank-li{
              .rate{
                  .el-progress-bar{
                      .el-progress-bar__outer{
                          background-color: transparent;
                          border-radius: 0;
                          .el-progress-bar__inner{
                              border-radius: 0;
                          }
                      }
                      .el-progress__text{
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #6EA0D3;
                      }
                  }
              }
          }
      }
  }
  </style>